import * as rive from '@rive-app/canvas'
import { ELITE_RENEW_TEXT_RUN } from '../types/eliteWrapped.types'

/** Names embedded in elite-recap.riv; runtime confirms which resolve via getTextRunValue. */
const ELITE_RECAP_TEXT_RUN_CANDIDATES = [
  ELITE_RENEW_TEXT_RUN,
  'Renew your PowerUp Elite',
  '-Renew your PowerUp Elite',
  'membership instantly',
  ...Array.from({ length: 12 }, (_, frameIndex) =>
    Array.from({ length: 6 }, (_, lineIndex) => `Line${lineIndex + 1}_${frameIndex}`)
  ).flat()
]

export function logRiveTextRuns(riveInstance: rive.Rive, label = 'Rive text runs') {
  const found: Record<string, string> = {}
  const missing: string[] = []

  for (const name of ELITE_RECAP_TEXT_RUN_CANDIDATES) {
    try {
      const value = riveInstance.getTextRunValue(name)
      if (value !== undefined) {
        found[name] = value
      } else {
        missing.push(name)
      }
    } catch {
      missing.push(name)
    }
  }

  console.log(`[${label}] present (${Object.keys(found).length}):`, found)
  if (missing.length > 0) {
    console.log(`[${label}] not found (${missing.length}):`, missing)
  }

  return found
}
